export const THROW_ERROR = "THROW_ERROR";
export const HANDLE_ERROR = "HANDLE_ERROR";
export const TIMEOUT_ERROR = "TIMEOUT_ERROR";
export const RESET_ERROR = "RESET_ERROR";
export const RESET_ERROR_SUCCESS = "RESET_ERROR_SUCCESS";
